var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"banners is-clearfix"},_vm._l((_vm.banners),function(banner,i){return _c('Banner',{key:banner.id,staticClass:"row",attrs:{"index":i,"banner":banner,"imageAlignment":_vm.imageAlignment}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }